import * as BrandConst from './BrandConst'
import StringConst from './StringConst'

export const LABEL_HOTEL_CONTACT_TYPE_EMERGENCY_CONTACTS = 'Emergency Contacts'
export const LABEL_HOTEL_CONTACT_TYPE_ONBOARDING_CONTACT = 'Hotel Contact'
export const LABEL_HOTEL_CONTACT_TYPE_HOTEL_CONTACTS = 'Hotel Contacts'
export const LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR = 'Choice Onboarding Contact'
export const LABEL_HOTEL_CONTACT_TYPE_ONLINE_TRAVEL_AGENT = 'OTA Contact'
/*
Onboarding status
*/
export const STATUS_GENERATED = 'GENERATED'
export const STATUS_IN_PROGRESS = 'IN_PROGRESS'
export const STATUS_READY_FOR_REVIEW = 'READY_FOR_REVIEW'
export const STATUS_UNDER_REVIEW = 'UNDER_REVIEW'
export const STATUS_REVIEW_COMPLETE = 'REVIEW_COMPLETE'
export const STATUS_COMPLETED = 'COMPLETED'
export const STATUS_CLOSED = 'CLOSED'
export const STATUS_LOAD_ERROR = 'LOAD_ERROR'

export const DISPLAY_STATUS_NOT_STARTED = 'Not Started'
export const DISPLAY_STATUS_STARTED = 'In Progress'
export const DISPLAY_STATUS_READY_FOR_REVIEW = 'Ready for Review'
export const DISPLAY_STATUS_UNDER_REVIEW = 'Under Review'
export const DISPLAY_STATUS_REVIEW_COMPLETE = 'Review Complete'
export const DISPLAY_STATUS_COMPLETED = 'Completed'
export const DISPLAY_STATUS_CLOSED = 'Closed'
export const DISPLAY_STATUS_ERROR = 'Error'

export const STATUS_LIST_HOTEL_OWNER_READ_ONLY = [STATUS_READY_FOR_REVIEW, STATUS_UNDER_REVIEW, STATUS_COMPLETED, STATUS_CLOSED, STATUS_LOAD_ERROR]
export const STATUS_LIST_HOTEL_OWNER_EDIT = [STATUS_GENERATED, STATUS_IN_PROGRESS]

/*
Onboarding application actions
*/
export const ACTION_ACQUIRE_USER = 'ACQUIRE_USER'
export const ACTION_CREATE_APPLICATION = 'CREATE_APPLICATION'
export const ACTION_START_APPLICATION = 'START_APPLICATION'
export const ACTION_START_REVIEW = 'START_REVIEW'
export const ACTION_SUBMIT_APPLICATION = 'SUBMIT_APPLICATION'
export const ACTION_APPROVE_APPLICATION = 'APPROVE_APPLICATION'
export const ACTION_REASSIGN_APPLICATION = 'REASSIGN_APPLICATION'
export const ACTION_CLOSE_APPLICATION = 'CLOSE_APPLICATION'
export const ACTION_UPDATE_TERMS_AND_CONDITIONS = 'UPDATE_TERMS_AND_CONDITIONS'
export const ACTION_SAVE = 'SAVE'
export const ACTION_SAVE_AND_PROCEED = 'SAVE_AND_PROCEED'
export const ACTION_PUT = 'PUT'
export const ACTION_GET = 'GET'


export const DISPLAY_ACTION_START = 'Start'
export const DISPLAY_ACTION_CONTINUE = 'Continue'
export const DISPLAY_ACTION_REVIEW = 'Review'
export const DISPLAY_ACTION_VIEW = 'View'

export const START_APPLICATION_TEXT_HOTEL_CONTACT = 'Basic Hotel Information setup is complete. Do you want to begin the Onboarding process?'
export const START_APPLICATION_TEXT_ADMIN = 'Basic Hotel Information setup is complete. Do you want to begin the Onboarding process on behalf of the Hotel Contact?'

/*
Checklist status
 */
export const CHECKLIST_STATUS_COMPLETED = 'COMPLETED'
export const CHECKLIST_STATUS_IN_PROGRESS = 'IN_PROGRESS'

/*
Form Header
*/
export const FEEDBACK_LINK_TEXT_NON_ADMIN = 'Report an issue'
export const FEEDBACK_LINK_TEXT_ADMIN = 'Manage Record'
export const BACK_TO_FORM_LINK_TEXT = 'Go back to form'
export const RECAP_LINK_TEXT = 'Recap'

/*
Form names
*/
export const FORM_ADMIN_PAGE_NAME = 'FORM_ADMIN_PAGE'
export const FORM_AGE_TIERS_NAME = 'FORM_AGE_TIERS'
export const FORM_UPDATE_ONBOARDING_NAME = 'FORM_UPDATE_ONBOARDING'
export const FORM_LAUNCH_ONBOARDING_APPLICATION_NAME = 'FORM_LAUNCH_ONBOARDING_APPLICATION'
export const FORM_HOTEL_AMENITIES_NAME = 'FORM_HOTEL_AMENITIES_NAME'
export const FORM_HOTEL_INFO_NAME = 'FORM_HOTEL_INFO'
export const FORM_HOTEL_CONTACTS_NAME = 'FORM_HOTEL_CONTACTS'
export const FORM_HOTEL_DESTINATIONS_NAME = 'FORM_DESTINATIONS'
export const FORM_HOTEL_ONBOARDING_CONTACT_NAME = 'FORM_HOTEL_ONBOARDING_CONTACT'
export const FORM_HOTEL_ONLINE_DISPLAY_NAME = 'FORM_HOTEL_ONLINE_DISPLAY'
export const FORM_HOTEL_CONTENT_NAME = 'FORM_HOTEL_CONTENT_NAME'
export const FORM_SEARCH_HOTEL_NAME = 'FORM_SEARCH_HOTEL'
export const FORM_MEETING_ROOMS_NAME = 'FORM_MEETING_ROOMS'
export const FORM_ROOM_TYPES_NAME = 'FORM_ROOM_TYPES'
export const FORM_ROOM_TYPE_BUCKETS = 'FORM_ROOM_TYPE_BUCKETS'
export const FORM_EXTRA_CHARGES_NAME = 'FORM_EXTRA_CHARGES'
export const FORM_HOTEL_CHARGES_NAME = 'FORM_HOTEL_CHARGES'
export const FORM_PET_POLICY_NAME = 'FORM_PET_POLICY'
export const FORM_GUARANTEE_CANCEL_POLICY_NAME = 'FORM_GUARANTEE_CANCEL_POLICY'
export const FORM_GROUP_POLICY_NAME = 'FORM_GROUP_POLICY'
export const FORM_BOX_INVENTORY_NAME = 'FORM_BOX_INVENTORY'
export const FORM_SRP_INVENTORY_NAME = 'FORM_SRP_INVENTORY'
export const FORM_OTA_RATE_PROGRAMS_NAME = 'FORM_OTA_RATE_PROGRAMS'
export const FORM_OTHER_RATEPLANS_NAME = 'FORM_OTHER_RATEPLANS'
export const FORM_RATEPLAN_BLACKOUTS_NAME = 'FORM_RATEPLAN_BLACKOUTS'
export const FORM_INVENTORY_CLOSEOUTS_NAME = 'FORM_INVENTORY_CLOSEOUTS'
export const FORM_RACK_RATES_NAME = 'FORM_RACK_RATES'
export const FORM_FEEDBACK_NAME = 'FORM_FEEDBACK'
export const FORM_TERMS_AND_CONDITIONS_NAME = 'FORM_TERMS_AND_CONDITIONS'
export const FORM_ALL_NAME = 'FORM_ALL'

/*
Form ids
*/
export const FORM_HOTEL_TEXT_ID = 'hotelText'
export const FORM_HOTEL_CONTACTS_ID = 'hotelContacts'
export const SAVE_LINK_TEXT = 'Save'
export const DELETE_LINK_TEXT = 'Delete'
export const CLEAR_LINK_TEXT = 'Clear'
export const RESET_LINK_TEXT = 'Reset'
export const DISCARD_LINK_TEXT = 'Discard'

/*
Button text
*/
export const SAVE_ONLY_BUTTON_TEXT = 'Save'
export const SAVE_BUTTON_TEXT = 'Save & Proceed'
export const PROCEED_BUTTON_TEXT = 'Proceed'
export const CLEAR_BUTTON_TEXT = 'Clear Form'
export const RESET_BUTTON_TEXT = 'Reset Form'
export const REPORT_ISSUE_BUTTON_TEXT = 'Submit'
export const RESOLVE_ISSUE_BUTTON_TEXT = 'Resolve'
export const CONFIGURE_BUTTON_TEXT = 'Configure'

/*
Modal texts
*/
export const MODAL_TITLE = 'Alert'
export const MODAL_READ_ACTION_TITLE = 'Processing'
export const MODAL_READ_ACTION_TEXT = 'Please wait'
export const MODAL_DOWNLOAD_ACTION_TEXT = 'We are preparing your file, please wait...'
export const MODAL_DASHBOARD_READ_ACTION_TEXT = 'Loading status dashboard'
export const MODAL_DASHBOARD_ERROR_TEXT = 'Error loading dashboard data'
export const MODAL_READ_ACTION_ERROR_TEXT = 'There was an error while reading data'
export const MODAL_READ_ACTION_ERROR_HISTORY_TEXT = 'There was an error while reading data from history'
export const MODAL_UPDATE_ACTION_TITLE = 'Processing'
export const MODAL_UPDATE_ACTION_TEXT = 'Please wait for the form to be saved'
export const MODAL_UPDATE_ACTION_ERROR_TITLE = 'Error'
export const MODAL_UPDATE_ACTION_ERROR_TEXT = 'There was an error while updating data'
export const MODAL_UPDATE_ACTION_LOCK_ERROR_TEXT = 'The lock to edit this application was acquired by another user'
export const MODAL_UPDATE_ACTION_AUTH_ERROR_TEXT = 'Login expired'
export const MODAL_DELETE_ACTION_TEXT = 'Please confirm your action to delete'
export const MODAL_RESET_ACTION_TITLE = 'Reset Form'
export const MODAL_RESET_ACTION_TEXT = 'Please confirm your action to reset'
export const MODAL_DISCARD_ACTION_TITLE = 'Discard Form'
export const MODAL_DISCARD_ACTION_TEXT = 'Please confirm your action to discard'
export const MODAL_UPDATE_LOCK_TEXT = 'Updating lock status'
export const MODAL_ACQUIRE_LOCK_TEXT = 'The lock to edit this application is acquired by another user. Do you want to acquire the lock?'
export const MODAL_REFRESH_TOKEN_TITLE = 'Refresh Sign In'
export const MODAL_REFRESH_TOKEN_TEXT = 'The session is about to expire. Do you want to extend it?'
export const MODAL_SEARCH_HOTEL_TEXT = 'Searching for record'
export const MODAL_RATE_PLAN_TITLE = 'Rate Plans'
export const MODAL_RATE_PLAN_DETAILS = 'Rate Plan Details'
export const MODAL_RATES_TITLE = 'Rates'
export const MODAL_RATES_DETAILS = 'Rates Details'
export const MODAL_FORM_LAYOUT_TEXT = 'Retrieving onboarding application status'
export const MODAL_RECAP_CONFIRMATION_TEXT = 'Would you like to proceed with the recap?'
export const MODAL_RECAP_SUCCESS_TEXT = 'Successfully recapped'
export const MODAL_RECAP_ERROR_TEXT = 'There was an error while processing the recap'
export const MODAL_RECAP_INVALID_STATUS_ERROR_TEXT = 'This hotel is already active and cannot be recapped. Recap works for New and Inactive hotels'
export const MODAL_MASTER_BOX_TITLE = 'Master Box'
export const MODAL_MASTER_BOX_DETAILS = 'Master Box Details'
export const MODAL_ROOM_TYPE_ADD_WARNING = 'Adding a new room type will reset rack rate completetion status. Do you want to proceed?'

/*
Form Header
*/
export const IS_UNDER_REVIEW_SUBMITTED_READ_ONLY_MODE_TEXT=`The application for this hotel is under review. If changes are needed, please contact your ${LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.`
export const IS_READY_FOR_REVIEW_READ_ONLY_MODE_TEXT=`The application for this hotel is ready for review. If changes are needed, please contact your ${LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.`
export const IS_COMPLETE_READ_ONLY_MODE_TEXT=`The application for this hotel is in Completed state. If changes are needed, please contact your ${LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.`
export const IS_CLOSED_READ_ONLY_MODE_TEXT=`The application for this hotel is in Closed state. If changes are needed, please contact your ${LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.`
export const IS_LOCKED_READ_ONLY_MODE_TEXT='The permission to edit hotel details is acquired by '
export const IS_READ_ONLY_USER_TEXT='The current user has read only permissions'

export const RATE_PLAN_CONFIGURATION_TYPE_STANDARD = 'STANDARD'
export const RATE_PLAN_CONFIGURATION_TYPE_STANDARD_VALUE = 'STD'

export const RATE_PLAN_CONFIGURATION_TYPE_LINKED = 'LINKED'
export const RATE_PLAN_CONFIGURATION_TYPE_LINKED_VALUE = 'LNK'


export const VALUE_YES = 'Yes'
export const VALUE_NO = 'No'
export const VALUE_EMPTY = ''
export const VALUE_TRUE_STRING = 'true'
export const VALUE_FALSE_STRING = 'false'
export const VALUE_COMPLETE = 'Complete'
export const VALUE_PENDING = 'Pending'
export const VALUE_WORK = 'WORK'
export const VALUE_HOME = 'HOME'
export const VALUE_MOBILE = 'MOBILE'
export const VALUE_PRIMARY = 'PRIMARY'
export const VALUE_FAX = 'FAX'
export const VALUE_PER_ROOM_PER_NIGHT = 'Per Room Per Night'
export const VALUE_PER_ROOM_PER_STAY = 'Per Room Per Stay'
export const VALUE_PER_PERSON_PER_NIGHT = 'Per Person Per Night'
export const VALUE_PER_PERSON_PER_STAY = 'Per Person Per Stay'
export const VALUE_ONSITE = 'Onsite'
export const VALUE_NEARBY = 'Nearby'
export const VALUE_ADJACENT = 'Adjacent'
export const LABEL_ONSITE = 'On-site'
export const VALUE_METRIC_MEASUREMENT_UNIT = 'METRIC'
export const VALUE_STANDARD_MEASUREMENT_UNIT = 'STANDARD'

export const VALUE_MILES = 'MI'
export const VALUE_KILOMETERS = 'KM'
export const LABEL_MILES = 'Miles'
export const LABEL_KILOMETERS = 'Kilometers'
export const VALUE_FEET = 'ft.'
export const VALUE_METERS = 'm.'
export const VALUE_SQUARE_FOOT = 'sq. ft.'
export const VALUE_SQUARE_METERS = 'sq. m.'
export const VALUE_POUNDS = 'Pounds'
export const VALUE_KILOGRAMS = 'Kilograms'

export const VALUE_STANDARD_DISTANCE_UNIT = VALUE_MILES
export const VALUE_METRIC_DISTANCE_UNIT = VALUE_KILOMETERS
export const LABEL_STANDARD_DISTANCE_UNIT = LABEL_MILES
export const LABEL_METRIC_DISTANCE_UNIT = LABEL_KILOMETERS
export const VALUE_STANDARD_LENGTH_UNIT = VALUE_FEET
export const VALUE_METRIC_LENGTH_UNIT = VALUE_METERS
export const VALUE_STANDARD_AREA_UNIT = VALUE_SQUARE_FOOT
export const VALUE_METRIC_AREA_UNIT = VALUE_SQUARE_METERS
export const VALUE_STANDARD_WEIGHT_UNIT = VALUE_POUNDS
export const VALUE_METRIC_WEIGHT_UNIT = VALUE_KILOGRAMS

export const LABEL_ALL_STATES = 'All States or Provinces'
export const VALUE_ALL_STATES = 'ALL_STATES'

export const HOTEL_CHARGE_CODE_PERCENTAGE_TAX = 'HTTX'
export const HOTEL_CHARGE_CODE_FLAT_TAX = 'FLTX'
export const HOTEL_CHARGE_CODE_HOTEL_FEES_TAX = 'RSFE'

export const HOTEL_CHARGE_DESCRIPTION_PERCENTAGE_TAX = 'Hotel Tax'
export const HOTEL_CHARGE_DESCRIPTION_FLAT_TAX = 'Hotel Flat Tax'
export const HOTEL_CHARGE_DESCRIPTION_HOTEL_FEES_TAX = 'Hotel Resort Fees'

export const HOTEL_CHARGE_AMOUNT_TYPE_PERCENT = 'PERCENT'
export const HOTEL_CHARGE_AMOUNT_TYPE_FIXED = 'FIXED'
export const DATE_PATTERN = /^\d\d\d\d[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])$/
export const TIME_24H_PATTERN = /^(|0?[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/
export const MAX_VALUE_DATE = '2099-12-31'
export const MIN_VALUE_DATE = '2021-01-01'
export const MAX_YEARS_END_DATE = 10;

export const PATTERN_ALPHANUMERIC = /^\w*$/

/*
Validation error messages
*/
export const VALIDATION_ERROR_DATE_PATTERN = 'Valid pattern is YYYY-mm-dd'
export const VALIDATION_ERROR_DESTINATIONS_DISTANCE = 'Maximum allowed value is 999'
export const VALIDATION_ERROR_TIME_PATTERN = 'Valid 24 hour pattern is HH:MM'
export const VALIDATION_ERROR_REQUIRED = 'Required'
export const VALIDATION_ERROR_TYPE_NUMBER = 'Must be a number'
export const VALIDATION_ERROR_EMAIL_PATTERN = 'Valid email required'
export const VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO = 'Should be greater than 0'
export const VALIDATION_ERROR_NUMBER_GREATER_THAN_OR_EQUAL_TO_ZERO = 'Should be greater than or equal to 0'
export const VALIDATION_ERROR_MINIMUM_VALUE_ZERO = 'Minimum value is 0'
export const VALIDATION_ERROR_NUMBERS_ONLY = 'Numbers only'
export const VALIDATION_ERROR_SPECIAL_CHARACTERS = 'Invalid special characters. Allowed special characters are . , - /'
export const VALIDATION_ERROR_ALPHA_NUMERIC_CHARACTERS = 'Invalid special characters. Only alphanumeric characters are allowed'
export const VALIDATION_ERROR_RATES_VALUES_SIZE = 'Allowed values are 0 to 99999'
export const VALIDATION_ERROR_ADR_AND_PERSON_AMOUNT_NOT_ALLOWED = 'Cannot have adr amounts with person amounts'
export const VALIDATION_ERROR_ADR_OR_PERSON_AMOUNT_REQUIRED = 'Adr amounts or person amounts required'
export const VALIDATION_ERROR_MAX_HOTEL_ALERTS_REACHED = `Maximum 12 alerts allowed`
export const VALIDATION_ERROR_DATE_STRING_TOO_LONG = 'The Date can only be 10 characters long'
export const VALIDATION_ERROR_MIN_START_DATE = 'The Date cannot be before today'
export const VALIDATION_ERROR_MAX_END_DATE = 'End date cannot exceed '+MAX_YEARS_END_DATE+' years'
export const VALIDATION_ERROR_MAX_AVAILABLE_TOTAL_AREA = 'Cannot be higher than calculated total area'
export const VALIDATION_ERROR_URL_FORMAT = 'Invalid URL format - Valid format is http://www.example.com'
export const VALIDATION_ERROR_FEMA_ID_FORMAT = "Invalid FEMA ID format - Valid format is six characters long and alphanumeric"

export const PAGE_NOT_ACCESSIBLE_ON_DEVICE = 'This page is not accessible on this device. Please access this from a device with a width of 1200px or more.'

/*
Search Hotel Page
*/
export const APPLICATION_SUBMITTED_STATUS_LIST = [STATUS_READY_FOR_REVIEW, STATUS_UNDER_REVIEW, STATUS_COMPLETED, STATUS_CLOSED]
export const READ_ONLY_STATUS_LIST_ADMINS = [STATUS_READY_FOR_REVIEW, STATUS_COMPLETED, STATUS_CLOSED]
export const READ_ONLY_STATUS_LIST_NON_ADMINS = [STATUS_READY_FOR_REVIEW, STATUS_UNDER_REVIEW, STATUS_COMPLETED, STATUS_CLOSED]
export const DISABLE_ACQUIRE_LOCK_STATUS_LIST = [STATUS_CLOSED]

/*
Terms and Conditions Page
*/
export const TERMS_AND_CONDITIONS_VERSION = '1'

/*
Hotel info page
*/
export const HOTEL_INFO_DEFAULT_EMAIL_TYPE = VALUE_WORK

export const BRANDS_USE_LINKED_RATEPLAN_CONFIGURATION = [BrandConst.BRAND_CODE_WOODSPRING, BrandConst.BRAND_CODE_EVERHOME]
export const BRANDS_USE_MULTI_TIER_CONFIGURATION = [BrandConst.BRAND_CODE_SUBURBAN, BrandConst.BRAND_CODE_MAINSTAY]
export const BRANDS_ALLOW_OFFICE_HOURS_CONFIG = [BrandConst.BRAND_CODE_WOODSPRING, BrandConst.BRAND_CODE_SUBURBAN]

export const SCANDANAVIAN_PROPERTY_TAGS = ['_SCA_']

export const HOTEL_CHECK_IN_TIME_DEFAULT = '15:00'
export const HOTEL_CHECK_OUT_TIME_DEFAULT = '11:00'
export const CHILDREN_STAY_FREE_DOMESTIC_DEFAULT = true
export const CHILDREN_STAY_FREE_INTERNATIONAL_DEFAULT = false
export const MAX_CHILD_AGE_DOMESTIC_DEFAULT = 18    
export const MAX_CHILD_AGE_INTERNATIONAL_DEFAULT = 18
export const IS_TRAVEL_AGENT_COMMISSION_DOMESTIC_DEFAULT = true
export const IS_TRAVEL_AGENT_COMMISSION_INTERNATIONAL_DEFAULT = false
export const TRAVEL_AGENT_COMMISSION_DOMESTIC_DEFAULT = 10
export const TRAVEL_AGENT_COMMISSION_INTERNATIONAL_DEFAULT = 10
export const TAXES_INCLUDED_IN_RATES_DOMESTIC_DEFAULT = false
export const TAXES_INCLUDED_IN_RATES_INTERNATIONAL_DEFAULT = false
export const IS_OFFICE_HOURS_OPEN_ALL_DAYS_DEFAULT = true
export const VALUE_OFFICE_HOURS_OPEN = 'Open'
export const VALUE_OFFICE_HOURS_CLOSED = 'Closed'
export const VALUE_OFFICE_HOURS_OTHER = 'Other'

/*
Contacts page
*/

export const HOTEL_CONTACT_TYPE_EMERGENCY = 'Emergency'
export const HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR = 'Opening Service Director'
export const HOTEL_CONTACT_TYPE_ONBOARDING = 'Onboarding'
export const HOTEL_CONTACT_TYPE_ONLINE_TRAVEL_AGENT = 'Online Travel Agent'
export const HOTEL_CONTACTS_PHONE_NUMBER_TYPES = [{ label: VALUE_HOME, value: VALUE_HOME }, { label: VALUE_MOBILE, value: VALUE_MOBILE }, { label: VALUE_WORK, value: VALUE_WORK }, { label: 'FAX', value: 'FAX' }]
export const MAX_EMERGENCY_CONTACTS = 4
export const PATTERN_NUMBERS_ONLY = /^[0-9]*$/
export const FEMA_ID_PATTERN = /^[A-Za-z0-9]{6}$/

export const MAX_LENGTH_TITLE = 15
export const MAX_LENGTH_COUNTRY_CODE = 3
export const MAX_LENGTH_AREA_CODE = 5
export const MAX_LENGTH_PHONE_NUMBER = 18
export const MAX_LENGTH_RATES_VALUES = 99999
export const MAX_HOTEL_ALERTS = 12

/*
Hotel Online Display Mapping
*/
export const HOTEL_TEXT_TYPE_TO_FORM_NAME = {
    'Hotel Display Location': 'hotelDisplayLocation',
    'Driving Directions': 'drivingDirections',
    'Extended Driving Directions': 'extendedDrivingDirections',
    'Sales Pitch': 'salesPitch',
    'Hotel Alert': 'hotelAlerts'
}

export const HOTEL_TEXT_FORM_NAME_TO_TYPE = {
    'hotelDisplayLocation': 'Hotel Display Location',
    'drivingDirections': 'Driving Directions',
    'extendedDrivingDirections': 'Extended Driving Directions',
    'salesPitch': 'Sales Pitch',
    'hotelAlerts': 'Hotel Alert'
}

export const HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT = {
    'hotelDisplayLocation': 16,
    'drivingDirections': 500,
    'extendedDrivingDirections': 2000,
    'salesPitch': 12000,
    'hotelAlerts': 300
}

/*
Hotel Amenities page
*/
export const HOTEL_AMENITIES_CHARGE_POLICY_TYPES = {
    CHARGE_CANNOT_BE_APPLIED: 'Charge cannot be applied',
    CHARGE_DETERMINED_BY_HOTEL: 'Charge determined by hotel',
    CHARGE_MUST_BE_APPLIED: 'Charge must be applied'
}

export const PET_AMENITY_CODES = ['NPET', 'PETS', 'KENN']

/*
Meeting Rooms page
*/
export const meetingRoomCapacityConversionFactor = {
    domestic: {
        BANQUET: 0.08333,
        CONFERENCE_BOARDROOM: 0.02500,
        CLASSROOM: 0.06897,
        RECEPTION: 0.11111,
        THEATRE: 0.10526,
        U_SHAPE: 0.02778,
    },
    international: {
        BANQUET: 0.89699,
        CONFERENCE_BOARDROOM: 0.26910,
        CLASSROOM: 0.74233,
        RECEPTION: 1.19599,
        THEATRE: 1.13304,
        U_SHAPE: 0.29900,
    }
}

export const meetingRoomConfigurationCodes = {
    BANQUET: 'BQT',
    CONFERENCE_BOARDROOM: 'CBRM',
    CLASSROOM: 'CLSRM',
    RECEPTION: 'RCPT',
    THEATRE: 'THTR',
    U_SHAPE: 'USHP',
}

export const MAX_MEETING_ROOMS_COUNT = 25

/*
Destinations page
*/
export const DESTINATION_CODE_RESTAURANT_SPECIALITY = 'RSTSP'
export const DESTINATION_CODE_LONG_DISTANCE_TRANSPORT = 'LTRAN'
export const DESTINATION_CODE_LOCAL_TRANSPORT = 'STRAN'
export const DESTINATION_CODE_GROUP = 'GRP'

export const DESTINATION_TYPE_AIRPORT = 'AIRPORT'
export const DESTINATION_TYPE_ATTRACTION = 'ATTRACTION'
export const DESTINATION_TYPE_BUSINESS = 'OTHER'
export const DESTINATION_TYPE_LOUNGE = 'LOUNGE'
export const DESTINATION_TYPE_LONG_DISTANCE_TRANSPORTATION = 'LONGDISTTRANS'
export const DESTINATION_TYPE_LOCAL_TRANSPORTATION = 'LOCALTRANS'
export const DESTINATION_TYPE_SPA = 'SPA'

export const DESTINATIONS_CATEGORY_TRANSPORTATION_MIN_COUNT = 1
export const DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MIN_COUNT = 1
export const DESTINATIONS_CATEGORY_TRANSPORTATION_MAX_COUNT = 3
export const DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MAX_COUNT = 15
export const DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_SUGGESTED_COUNT = 5

export const MAX_DESTINATION_DISTANCE = 999
export const DESTINATION_NAME_MAX_LENGTH = 40
export const RATE_PLAN_CODE_MAX_LENGTH = 16
export const MASTER_BOX_BOX_NAME_MAX_LENGTH = 25
export const MASTER_BOX_DESCRIPTION_MAX_LENGTH = 255

export const HOTEL_CONTENT_DEFAULT_SECTIONS = {
    AC : "DSW",
    BR : "DSW",
    RB : "DSW",
    RR : "DSW",
    RC : "DSW",
    RV : "DSW",
    RD : "DSW",
    PK : "DSW",
	SW : "DSW",
    CL : "D",
    PD : "D"
}
export const HOTEL_CONTENT_INTERNATIONAL_ONLY_BRAND = 'PD';
export const HOTEL_CONTENT_TYPE_MAX_CHARACTER_LIMIT = {
    'shortDescription' : 2000
}
export const MAX_LENGTH_SHORT_DESCRIPTION = 2000
export const WEDDING_CONTENT_CODE = "W";

/*
Airports page
*/
export const DIRECTION_OPTIONS = [
    { label: 'W', value: 'WEST' }, { label: 'NW', value: 'NORTHWEST' }, { label: 'N', value: 'NORTH' }, { label: 'NE', value: 'NORTHEAST' },
    { label: 'E', value: 'EAST' }, { label: 'SE', value: 'SOUTHEAST' }, { label: 'S', value: 'SOUTH' }, { label: 'SW', value: 'SOUTHWEST' }
]

/*
Room Types page
*/
export const ACCESSIBLE = 'Accessible'
export const MOBILITY_ACC = 'Mobility Accessible'
export const HEARING_ACC = 'Hearing Accessible'
export const MOB_HEARING_ACC = 'Mobility & Hearing Accessible'
export const ACCESSIBILITY_VALUES_LIST = [ACCESSIBLE, MOBILITY_ACC, HEARING_ACC, MOB_HEARING_ACC]
export const ROOM_TYPE_BUCKET = "Room Type Bucket"
export const LABEL_ROOM_TYPES = "Unassigned Room Types"
export const LABEL_ROOM_TYPE_BUCKET = "Room Type Bucket"
export const LABEL_ROOM_TYPE_BUCKETS = "Room Type Buckets"
export const LABEL_ROOM_TYPE_BUCKET_FORM = "Room Type Bucket Form"
export const LABEL_ADD_ROOM_TYPE_BUCKET = "Add Room Type Bucket"
export const MAX_ROOM_TYPE_BUCKETS = 20
export const MIN_ROOM_TYPE_AMENITIES = 1
export const MIN_ROOM_TYPE_AMENITIES_MESSAGE = 
<>
At least one amenity must be selected.
</>

/*
RACK Rates screen
*/
export const CONDITION_VALUE_ONE_PERSON = 'ONE_PERSON'
export const CONDITION_VALUE_TWO_PERSON = 'TWO_PERSON'
export const TIER_1 = '1'
export const TIER_2 = '2'
export const TIER_3 = '3'
export const TIER_4 = '4'
export const RATEPLAN_CODE_SBASE1 = 'SBASE1'
export const RATEPLAN_CODE_SBASE2 = 'SBASE2'
export const RATEPLAN_CODE_SBASE3 = 'SBASE3'
export const RATEPLAN_CODE_SBASE4 = 'SBASE4'

export const FIELD_RATEPLAN_CODE = 'ratePlanCode'
export const FIELD_RATEPLAN_NAME = 'ratePlanName'
export const FIELD_RATEPLAN_TYPE = 'ratePlanType'
export const FIELD_PARTICIPATING = 'participating'
export const FIELD_1P = '1P'
export const FIELD_2P = '2P'
export const FIELD_MONDAY = 'monday'
export const FIELD_TUESDAY = 'tuesday'
export const FIELD_WEDNESDAY = 'wednesday'
export const FIELD_THURSDAY = 'thursday'
export const FIELD_FRIDAY = 'friday'
export const FIELD_SATURDAY = 'saturday'
export const FIELD_SUNDAY = 'sunday'

export const MIN_YEARS_RACK_RATE_DEFAULT = 10
export const PATTERN_MAX_TWO_DECIMALS = /^\d+(\.\d{1,2})?$/
export const MIN_RACK_RATES_VALUE = 20.01

/*
Box Inventory page
*/
export const BOX_NAME_EMPLOY = 'EMPLOY'
export const BOX_NAME_E = 'E'
export const BOX_NAME_GROUP = 'GGROUP'
export const BOX_NAME_NET = 'NET'
export const BOX_NAME_EXTNT = 'EXTNT'
export const BOX_DESCRIPTION_NET = 'Third party Rate Programs'
export const BOX_INVENTORY_VALIDATION_REGEX = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/
export const MIN_ROOMS_REQUIRED_BOX_CAMBRIA = 1
export const MIN_ROOMS_REQUIRED_BOX_DEFAULT = 2
export const MIN_ROOMS_SUGGESTED_BOX_DEFAULT = 1
export const MIN_ROOMS_REQUIRED_BOX = {
    [BOX_NAME_EMPLOY]: 2,
    [BOX_NAME_E]: 10,
    [BOX_NAME_GROUP]: 1,
    [BOX_NAME_NET]: 1,
    [BOX_NAME_EXTNT]: 1
}
export const MIN_ROOMS_SUGGESTED_BOX = {
    [BOX_NAME_EMPLOY]: 2,
    [BOX_NAME_E]: 10,
    [BOX_NAME_GROUP]: 40,
    [BOX_NAME_NET]: 20,
    [BOX_NAME_EXTNT]: 20
}

/* Rate programs page
*/
export const FINANCIAL_INFO_PAYMENT_TYPES = [
    { label: 'Wire', value: 'Wire' },
    { label: 'Check', value: 'Check' },
    { label: 'Credit Card', value: 'Credit Card' }
]

export const FINANCIAL_INFO_TAX_STATUS_TYPE = [
    { label: 'Corporation', value: 'Corporation' },
    { label: 'LLC', value: 'LLC' },
    { label: 'S Corporation', value: 'S Corporation' },
    { label: 'Sole Proprietor', value: 'Sole Proprietor' }
]
export const OTA_RATE_PROGRAM_CODE_EXPEDIA = 'EXPD'
export const ADA_THRESHOLD_DEFAULT = 1
export const NON_ADA_THRESHOLD_DEFAULT = 1
export const EXPEDIA_TAX_ID_REGEX_US = /^[0-9]{9}$/
export const EXPEDIA_TAX_ID_REGEX_NON_US = /^[ A-Za-z0-9_@./#&+-]{9,25}$/
export const EXPEDIA_TAX_ID_REGEX_US_SUFIX = '(US tax ID must be 9 digits)'
export const EXPEDIA_TAX_ID_REGEX_NON_US_SUFIX = '(NON-US tax ID must be min 9 and max 25 characters)'

/*
Other Rate Plans screen
*/
export const RATE_TYPE_FLAT = 'FLAT'
export const RATE_TYPE_PERCENT = 'PERCENT'
export const RATE_TYPE_AMOUNT = 'AMOUNT'
export const LABEL_RATE_TYPE_FLAT = 'Flat Amount'
export const LABEL_RATE_TYPE_PERCENT = 'Percent off BAR'
export const LABEL_RATE_TYPE_AMOUNT = 'Amount off BAR'
export const RATE_TYPES_OPTIONS = [
    { label: LABEL_RATE_TYPE_FLAT, value: RATE_TYPE_FLAT },
    { label: LABEL_RATE_TYPE_PERCENT, value: RATE_TYPE_PERCENT }
]
export const RATE_TYPES_OPTIONS_SAME_LABEL_AND_VALUE = [
    { label: RATE_TYPE_FLAT, value: RATE_TYPE_FLAT },
    { label: RATE_TYPE_PERCENT, value: RATE_TYPE_PERCENT }
]
export const RATE_TYPE_TO_RATE_TYPE_LABEL = {
    [RATE_TYPE_FLAT]: LABEL_RATE_TYPE_FLAT,
    [RATE_TYPE_PERCENT]: LABEL_RATE_TYPE_PERCENT,
    [RATE_TYPE_AMOUNT]: [LABEL_RATE_TYPE_AMOUNT]
}
export const ADJUSTMENT_TYPE_OFF = 'OFF'
export const RATEPLAN_CODE_BASE = 'BASE'
export const RATEPLAN_CODE_SGM = 'SGM'
export const RATEPLAN_CODE_STATE = 'STATE'
export const RATEPLAN_CODE_STATE_SGM = 'STATE/SGM'
export const RATEPLAN_CODE_SED = 'SED'
export const RATEPLAN_CODE_SFF = 'SFF'
export const RATEPLAN_NAME_STATE_SGM = 'Government/State Government Rate'
export const RATEPLAN_CODE_SRD = 'SRD'




/*
Rateplan Blackouts screen
*/
export const BLACKOUTS_DAYS_COUNT_DEFAULT = 30
export const BLACKOUTS_DAYS_COUNT_ASCEND = 90
export const BLACKOUTS_DAYS_COUNT_CAMBRIA = 90

/*
Guarantee and Cancel Policy page
*/
export const GUARANTEE_POLICY_TO_CANCEL_POLICY_MAPPING = {
    '4P': ['4P'],
    '6P': ['6P'],
    'GTD': ['4P', '6P', '24H', '48H', '72H', '5D', '7D', '10D', '14D', '30D', '60D', '90D'],
    'CCO': ['4P', '6P', '24H', '48H', '72H', '5D', '7D', '10D', '14D', '30D', '60D', '90D'],
    'PPD': ['24H', '48H', '72H', '5D', '7D', '10D', '14D', '15D', '21D', '22D', '30D', '60D', '90D'],
    'DEP': ['4P', '6P', '24H', '48H', '72H', '5D', '7D', '10D', '14D', '15D', '21D', '22D', '30D', '45D', '60D', '90D']
}
export const GUARANTEE_POLICY_OPTIONS = Object.keys(GUARANTEE_POLICY_TO_CANCEL_POLICY_MAPPING).map(guaranteePolicy => {
    return {
        label: guaranteePolicy,
        value: guaranteePolicy
    }
})

export const POLICY_TYPE_GUARANTEE_POLICY = 'GTD'
export const POLICY_TYPE_CANCEL_POLICY = 'CXL'
export const MIN_YEARS_GUARANTEE_CANCEL_POLICY_DEFAULT = 10

/*
Pet policy page
*/
export const AMENITY_CODE_PETS = 'PETS'
export const AMENITY_CODE_NPET = 'NPET'
export const AMENITY_CODE_KENN = 'KENN'
export const VALUE_NO_KENNEL = 'No Kennel'

/*
Admin Hotel List page
*/
export const HOTEL_ONBOARDING_STATUS_TO_ACTION = {
    [STATUS_GENERATED]: DISPLAY_ACTION_START,
    [STATUS_IN_PROGRESS]: DISPLAY_ACTION_CONTINUE,
    [STATUS_READY_FOR_REVIEW]: DISPLAY_ACTION_REVIEW,
    [STATUS_UNDER_REVIEW]: DISPLAY_ACTION_REVIEW,
    [STATUS_REVIEW_COMPLETE]: DISPLAY_ACTION_REVIEW,
    [STATUS_COMPLETED]: DISPLAY_ACTION_VIEW,
    [STATUS_LOAD_ERROR]:DISPLAY_ACTION_REVIEW
}

export const HOTEL_ONBOARDING_DISPLAY_STATUS_TO_STATUS = {
    [DISPLAY_STATUS_NOT_STARTED]: STATUS_GENERATED,
    [DISPLAY_STATUS_STARTED]: STATUS_IN_PROGRESS,
    [DISPLAY_STATUS_READY_FOR_REVIEW]: STATUS_READY_FOR_REVIEW,
    [DISPLAY_STATUS_UNDER_REVIEW]: STATUS_UNDER_REVIEW,
    [DISPLAY_STATUS_REVIEW_COMPLETE]: STATUS_REVIEW_COMPLETE,
    [DISPLAY_STATUS_COMPLETED]: STATUS_COMPLETED,
    [DISPLAY_STATUS_CLOSED]: STATUS_CLOSED,
    [DISPLAY_STATUS_ERROR]: STATUS_LOAD_ERROR
}

export const HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS = {
    [STATUS_GENERATED]: DISPLAY_STATUS_NOT_STARTED,
    [STATUS_IN_PROGRESS]: DISPLAY_STATUS_STARTED,
    [STATUS_READY_FOR_REVIEW]: DISPLAY_STATUS_READY_FOR_REVIEW,
    [STATUS_UNDER_REVIEW]: DISPLAY_STATUS_UNDER_REVIEW,
    [STATUS_REVIEW_COMPLETE]: DISPLAY_STATUS_REVIEW_COMPLETE,
    [STATUS_COMPLETED]: DISPLAY_STATUS_COMPLETED,
    [STATUS_CLOSED]: DISPLAY_STATUS_CLOSED,
    [STATUS_LOAD_ERROR]: DISPLAY_STATUS_ERROR
}

/*
Feedback Forms
*/
export const FEEDBACK_REPORT_ISSUE = 'Issue reported'
export const FEEDBACK_RESOLVE_ISSUE = 'Issue resolved'
export const FEEDBACK_MAXIMUM_LENGTH = 600
// export const FEEDBACK_PATTERN = /^[[A-Za-z0-9][\\?!]\\s-_:,;.]*$/
export const FEEDBACK_PATTERN = /^[A-Za-z0-9-_:,;.\s]*$/
export const TEXT_PATTERN = /^[A-Za-z0-9-,./\s]*$/
export const TEXT_PATTERN_ALPHA_NUMERIC = /^[A-Za-z0-9]*$/
export const getUpdateStatusFeedback = (oldStatus, newStatus) => `Updating onboarding status from ${oldStatus} to ${newStatus}`

/*
Validation schemas
*/
export const EMAIL_PATTERN = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/
export const PHONE_NUMBER_PATTERN = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
export const URL_PATTERN = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/

/*
Group Policy Page
*/
export const BREAKFAST_AMENITY_MAPPING = 
{
    'Free Continental Breakfast':'CONT',
    'Grab n Go Breakfast':'BFGO',
    'Continental Breakfast':'BFST',
    'Breakfast and Dinner':'BNDI',
    'Full Buffet Breakfast':'BUFF',
    'Free Deluxe Continental Breakfast':'DLUX',
    'Charge for Full Breakfast':'FLBC',
    'Free Full Breakfast':'FULL',
    'Free Hot Breakfast':'HOTB'
}
export const COMPLIMENTARY_ROOM_COUNT_DEFAULT = 20

/*
Form option lists
*/
export const OPTIONS_YES_NO = [{ label: VALUE_YES, value: VALUE_YES }, { label: VALUE_NO, value: VALUE_NO }]
export const OPTIONS_YES_NO_BOOLEAN = [{ label: VALUE_YES, value: true }, { label: VALUE_NO, value: false }]
export const SWITCH_OPTIONS_YES_NO = [VALUE_YES, VALUE_NO]
export const EMAIL_ADDRESS_TYPES = [{ label: VALUE_WORK, value: VALUE_WORK }, { label: VALUE_HOME, value: VALUE_HOME }, { label: VALUE_MOBILE, value: VALUE_MOBILE }]
export const HOTEL_OPENING_TYPES = [{ label: 'NEW CONSTRUCTION', value: 'NEW' }, { label: 'CONVERSION', value: 'CONVERSION' }]
export const RATE_PLAN_CONFIGURATION_TYPES = [
    { label: RATE_PLAN_CONFIGURATION_TYPE_STANDARD, value: RATE_PLAN_CONFIGURATION_TYPE_STANDARD_VALUE }, 
    { label: RATE_PLAN_CONFIGURATION_TYPE_LINKED, value: RATE_PLAN_CONFIGURATION_TYPE_LINKED_VALUE }
]
export const DISTANCE_UNIT_TYPES = [{ label: LABEL_MILES, value: VALUE_MILES }, { label: LABEL_KILOMETERS, value: VALUE_KILOMETERS }]
export const LOCATION_OPTIONS = [{ label: LABEL_ONSITE, value: VALUE_ONSITE }, { label: VALUE_ADJACENT, value: VALUE_ADJACENT }, { label: VALUE_NEARBY, value: VALUE_NEARBY }]
export const HOTEL_AMENITIES_LOCATION_OPTIONS = [{ label: LABEL_ONSITE, value: VALUE_ONSITE }, { label: VALUE_NEARBY, value: VALUE_NEARBY }]
// Other Rateplans SGM and STATE list of options
export const SGM_STATE_AMOUNT_OPTIONS = [
    { label: '0%', value: 0 },
    { label: '5%', value: 5 },
    { label: '10%', value: 10 },
    { label: '15%', value: 15 },
    { label: '20%', value: 20 }
]
// Description of Fire Safety Amenities
export const HOTEL_DEFAULT_FIRE_SAFETY_AMENITIES = [
    { code:"EVAC", description: "Evacuation Plan"},
    { code:"EXIT", description: "Multiple exits,floor"},
    { code:"EXTG", description: "Fire Extinguisher"},
    { code:"FDIH", description: "Fire Detectors, Hall"},
    { code:"FDPA", description: "Fire Detectors, Pubc"},
    { code:"FEXH", description: "Fire Extiguish, Hall"},
    { code:"LAWS", description: "Local Laws,fire/safe"},
    { code:"MAPS", description: "Emergency Exit Map"},
    { code:"SMOA", description: "Smoke Alarm, Audible"},
    { code:"SMOD", description: "Smoke Detectors"},
    { code:"SMOH", description: "Smoke Detector, Hall"},
    { code:"SMOP", description: "Smoke Detector, Pub"},
    { code:"SPRH", description: "Sprinklers, In-Hall"},
    { code:"SPRK", description: "Sprinkler Sys, Fire"},
    { code:"SPRP", description: "Sprinklers, Public"},
    { code:"VALM", description: "Visual Alarm"}
]
export const HOTEL_DEFAULT_AMENITY_CODES = HOTEL_DEFAULT_FIRE_SAFETY_AMENITIES.map(amenity => amenity.code);
export const IGNORED_AMENITY_CODES = ['NSKH', ...PET_AMENITY_CODES]
export const FEMA_AMENITY_CODE = 'FEMA'
export const KENNEL_OPTIONS_ONSITE_NEARBY = [{ label: LABEL_ONSITE, value: VALUE_ONSITE }, { label: VALUE_NEARBY, value: VALUE_NEARBY }, { label: VALUE_NO_KENNEL, value: VALUE_NO_KENNEL }]
export const PET_POLICY_CHARGE_TYPE = [{ label: 'Per Pet Per Night', value: 'Per Pet Per Night' }, { label: 'Per Pet Per Stay', value: 'Per Pet Per Stay' }, { label: 'Fixed Amount Per Night', value: 'Fixed Amount Per Night' }, { label: 'Fixed Amount Per Stay', value: 'Fixed Amount Per Stay' }]
export const PET_POLICY_DEPOSIT_FREQUENCY_TYPE = [{ label: 'Per Night', value: 'Per Night' }, { label: 'Per Stay', value: 'Per Stay' }]
export const GROUP_POLICY_BAGGAGE_SERVICE_OPTION = [{ label: 'Mandatory', value: 'Mandatory' }, { label: 'Optional', value: 'Optional' }]
export const GROUP_POLICY_CHARGE_BASIS = [{ label: 'Per Person', value: 'Per Person' }, { label: 'Per Bag', value: 'Per Bag' }, { label: 'Per Room', value: 'Per Room' }, { label: 'Per Bus', value: 'Per Bus' }]
export const GROUP_POLICY_BREAKFAST_AMENITIES = [
    { label: 'Brkfst,Contl FREE', value: 'Free Continental Breakfast' },
    { label: 'Breakfast, Grab n Go', value: 'Grab n Go Breakfast' },
    { label: 'Brkfst,Continental-Charge', value: 'Continental Breakfast' },
    { label: 'Breakfast and Dinner', value: 'Breakfast and Dinner' },
    { label: 'Brkfst, Full Buffet', value: 'Full Buffet Breakfast' },
    { label: 'Brkfst Dlx Cont Free', value: 'Free Deluxe Continental Breakfast' },
    { label: 'Full Breakfast-Chrg', value: 'Charge for Full Breakfast' },
    { label: 'Brkfst,Full,Free', value: 'Free Full Breakfast' },
    { label: 'Brkfst,Hot,Free', value: 'Free Hot Breakfast' }
]
export const OFFICE_HOURS_OPTIONS = [{ label: 'Open 24/7', value: 'Open' }, { label: 'Closed 24/7', value: 'Closed' }, { label: 'Specific', value: 'Other' }]
export const TAXES_CHARGE_FREQUENCY_TYPE_INTERNATIONAL = [
    { label: VALUE_PER_ROOM_PER_NIGHT, value: VALUE_PER_ROOM_PER_NIGHT }, { label: VALUE_PER_ROOM_PER_STAY, value: VALUE_PER_ROOM_PER_STAY },
    { label: VALUE_PER_PERSON_PER_NIGHT, value: VALUE_PER_PERSON_PER_NIGHT }, { label: VALUE_PER_PERSON_PER_STAY, value: VALUE_PER_PERSON_PER_STAY }
]
export const TAXES_CHARGE_FREQUENCY_TYPE_DOMESTIC = [
    { label: VALUE_PER_ROOM_PER_NIGHT, value: VALUE_PER_ROOM_PER_NIGHT }, { label: VALUE_PER_ROOM_PER_STAY, value: VALUE_PER_ROOM_PER_STAY }
]

export const REGION_AME = 'AME'
export const REGION_ANZ = 'ANZ'
export const REGION_BRZ = 'BRZ'
export const REGION_CAN = 'CAN'
export const REGION_CHN = 'CHN'
export const REGION_COL = 'COL'
export const REGION_DOM = 'DOM'
export const REGION_ECU = 'ECU'
export const REGION_EUR = 'EUR'
export const REGION_FRA = 'FRA'
export const REGION_JAP = 'JAP'
export const REGION_LTA = 'LTA'
export const REGION_MEX = 'MEX'
export const REGION_SCA = 'SCA'
export const REGION_SIN = 'SIN'
export const REGION_SPA = 'SPA'

export const REGION_OPTIONS = [
    { label: '', value: ''},
    { label: REGION_AME, value: REGION_AME},
    { label: REGION_ANZ, value: REGION_ANZ},
    { label: REGION_BRZ, value: REGION_BRZ},
    { label: REGION_CAN, value: REGION_CAN},
    { label: REGION_CHN, value: REGION_CHN},
    { label: REGION_COL, value: REGION_COL},
    { label: REGION_DOM, value: REGION_DOM},
    { label: REGION_ECU, value: REGION_ECU},
    { label: REGION_EUR, value: REGION_EUR},
    { label: REGION_FRA, value: REGION_FRA},
    { label: REGION_JAP, value: REGION_JAP},
    { label: REGION_LTA, value: REGION_LTA},
    { label: REGION_MEX, value: REGION_MEX},
    { label: REGION_SCA, value: REGION_SCA},
    { label: REGION_SIN, value: REGION_SIN},
    { label: REGION_SPA, value: REGION_SPA}
]

export const DEFAULT_ROOM_TYPE = 'STANDARD';

export const ROOM_CATEGORY_OPTIONS = [
    { label: 'Standard', value: 'STANDARD'},
    { label: 'Premium', value: 'PREMIUM_1'},
    { label: 'Premium 2', value: 'PREMIUM_2'},
    { label: 'Premium 3', value: 'PREMIUM_3'},
    { label: 'Premium 4', value: 'PREMIUM_4'},
    { label: 'Premium 5', value: 'PREMIUM_5'}
]

export const DEFAULT_HIDDEN_AMENITY_FOR_ROOM_TYPE = "SFBD"

export const ROOM_TYPE_AMENITIES_MAX_OCCUPANCY = [
    { code: "2SFB", value:4 },
    { code: "CSFB", value:1 },
    { code: "SFB1", value:1 },
    { code: "SFB2", value:2 },
    { code: "SFBD", value:2 }
]

/*
Roomtype
*/
export const EXTENDED_DESCRIPTION_MAXIMUM_LENGTH = 255
export const EXTENDED_DESCRIPTION_PLACEHOLDER_TEXT = "Please add description to show, what sets this room apart from the rest. For example: This room is amazing because it has a beautiful view of the lake, or this room allows guest exclusive access to areas within the hotel."
export const ROOM_TYPE_BUCKET_NAME_MAXIMUM_LENGTH = 32

export const ROOM_TYPE_AMENITIES_CODES_MAX_OCCUPANCY = ROOM_TYPE_AMENITIES_MAX_OCCUPANCY.map(amenity => amenity.code);

export const COMPLEMENTARY_ROOMS_OPTIONS = [
    { value: '10', label: '10' },
    { value: '15', label: '15' },
    { value: '20', label: '20' },
    { value: '25', label: '25' },
    { value: '30', label: '30' },
    { value: '35', label: '35' },
    { value: '40', label: '40' }
]

/*
Page helper texts
*/
export const SEARCH_HOTEL_HELPER_TEXT = 
<>
The purpose of {StringConst.APP_NAME} is to gather information regarding your hotel.
<br />
This information will be used for several purposes including:
<ul>
    <li>Producing your property landing page on Choicehotels.com or Woodspring.com</li>
    <li>Establishing your property profile in the GDS (Global Distribution Systems)</li>
    <li>Creating your property listing on the 3rd party website and additional distribution Channels</li>
    <li>Providing information that helps best sell your hotel to guests</li> 
</ul>
Please make sure to complete all of the following pages in their entirety.
<br />
If you need assistance or have any questions, please feel free to contact your {LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.
<br />
</>

export const HELPER_TEXT_PREFIX = <>You are doing great, so let's continue! <br /></>
export const HELPER_TEXT_REQUIRED_FIELDS = <>Items with an "*" are required fields.</>

export const HOTEL_INFO_HELPER_TEXT = <>Please supply the information requested below. {HELPER_TEXT_REQUIRED_FIELDS}</>

export const HOTEL_CONTACTS_ONBOARDING_OPD_HELPER_TEXT = 
<>
{HELPER_TEXT_PREFIX}
Communication is key to a successful onboarding experience. A key step of communication is establishing the correct points of contact.
In this section you will see the contact information for your Choice Onboarding team - your {LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.
We would also like for you to tell us who your Choice Onboarding team will be working with at the property.
Please provide the contact information below for “Hotel Contact”.
</>

export const HOTEL_CONTACTS_EMERGENCY_HELPER_TEXT = 
<>
Below you have the opportunity to provide Choice with up to 4 Emergency Contacts for the property. At least one Emergency Contact is required.
Your Emergency Contacts are used primarily when a catastrophic or emergency event occurs and Choice needs to contact the property, as well as when the need to reset your GM password.
If the need arises to contact one of your Emergency Contacts, they will attempt to contact in sequential order of the contacts listed below.  
</>

export const HOTEL_ONLINE_DISPLAY_HEPLER_TEXT = 
<>
{HELPER_TEXT_PREFIX}
This section will ask for information regarding how your hotel will be displaying online.
This information will be used by reservation agents as well online systems, and is used to help sell your hotel.
</>
export const HOTEL_DISPlAY_LOCATION_HELPER_TEXT = 
<>
Please fill in the cross streets or the nearest large intersection for your location.
This is used for mapping purposes and feeds to the GDS.<br />
Example: I-10, Exit 101.<br />
There is a {HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.hotelDisplayLocation} character limit.
</>
export const DRIVING_DIRECTIONS_HELPER_TEXT = 
<>
Please provide clear and precise directions to the property.
These directions feed to choicehotels.com and will be quoted by the reservation agents.<br />
Example: Traveling I-71 Northbound – Use the left lane to exit 2, Reading Road. 
Keep left and follow signs to N Reading road. Travel 0.5 miles and the hotel is on the left.<br />
There is a {HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.drivingDirections} character limit.
</>
export const EXTENDED_DRIVING_DIRECTIONS_HELPER_TEXT = 
<>
Please input additional driving directions if needed. This would be used if driving directions from multiple locations are needed.<br />
For example, driving directions may be needed from multiple airports in the area.<br />
There is a {HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.extendedDrivingDirections} character limit.
</>
export const SALES_PITCH_HELPER_TEXT = 
<>
Here is your opportunity to sell your hotel!<br />
Please input a property description that contains the best information to sell your hotel.<br />
Some examples are: Hotel is located in close proximity to the Airport; All rooms include a complimentary microwave and refrigerator; 
Hotel is located near several area attractions, etc.<br />
There is a {HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.salesPitch} character limit.
</>
export const HOTEL_ALERTS_HELPER_TEXT = 
<>
This section should be utilized for any restrictions or closures of hotel facilities that deviate from normal hotel operations.<br />
This information will be relayed to the guests by the reservation agents and will appear on your Choicehotels.com landing page.<br />
Please enter any Hotel Alerts individually, as you will be asked to put in a date range that the Alert is valid.<br />
Examples would include: Swimming Pool is closed for renovations; Complementarity Continental Breakfast is available Monday - Friday only, etc.<br />
There is a {HOTEL_TEXT_TYPE_MAX_CHARACTER_LIMIT.hotelAlerts} character limit per alert.
</>
export const EXTRA_CHARGES_HEPLER_TEXT = 
<>
{HELPER_TEXT_PREFIX}
This section will ask  for information regarding rollaway beds, cribs, extra person charges starting at the 3rd person.
</>
export const HOTEL_TAXES_HEPLER_TEXT = 
<>
{HELPER_TEXT_PREFIX}
This page is where you will input your tax rate information.
Please enter your total tax rate as a single percentage. 
Also, you have the opportunity to input an additional flat rate charge and any additional hotel fees, if applicable. 
Please remember any additional hotel fees must be disclosed to the guest prior to check-in.
</>
export const HOTEL_TAXES_HELPER_TEXT_DOMESTIC = 
<>
{HELPER_TEXT_PREFIX}
This page is where you input your tax rate information.
Please enter your total tax rate as a single percentage.  
Also, you will need to input any additional flat taxes or tourism taxes and mark the appropriate Charge Frequency.
Please remember that all taxes must be disclosed to the guest prior to completing a reservation.
</>
export const HOTEL_AMENITIES_HEPLER_TEXT = 
<>
{HELPER_TEXT_PREFIX}
Here is your opportunity to list any Hotel Amenities that are applicable to your hotel.
Based on your brand, suggested amenities will automatically appear. You do have the opportunity to delete any of these pre-populated brand amenities that may not be applicable, subject to approval by your {LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.
Please select all the additional amenities from the searchable amenities list, that best sell your unique property. Please note, you can also filter by category.
You can select multiple amenities at once by holding the Ctrl key.
</>
export const DESTINATIONS_LOCAL_ATTRACTIONS_HELPER_TEXT = 
<>
On the following pages you will be entering information regarding local restaurants, attractions, and businesses.
You can enter up to {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MAX_COUNT} entries in each of the sections, however a minimum of {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MIN_COUNT} is required.
It is highly recommended that you add as many entries as possible as these will appear on your website, and link to your third party listing.
The more entries you have the more attractive booking your hotel will be to a potential guest.
</>
export const DESTINATIONS_TRANSPORTATION_HELPER_TEXT =
<>
On the following pages you will have the opportunity to add the closest and major Airports near your property. 
You will also have the opportunity to add any transportation that may be used by your guests. 
This would include Bus Stations, Subway and Train Stations, and Local Taxi Service. You can enter up to {DESTINATIONS_CATEGORY_TRANSPORTATION_MAX_COUNT} entries in each of these sections, however a minimum of {DESTINATIONS_CATEGORY_TRANSPORTATION_MIN_COUNT} is required.
</>
export const AIRPORTS_HELPER_TEXT = 
<>
Please enter at least {DESTINATIONS_CATEGORY_TRANSPORTATION_MIN_COUNT} airport for your hotel and a maximum of {DESTINATIONS_CATEGORY_TRANSPORTATION_MAX_COUNT} airports.
If a new airport does not display in the search option, please notify your {LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.
</>
export const RESTAURANTS_HELPER_TEXT =
<>
We suggest adding {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_SUGGESTED_COUNT} to {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MAX_COUNT} restaurants, however a minimum of {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MIN_COUNT} is required.
</>
export const LOUNGES_HELPER_TEXT =
<>
We suggest adding {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_SUGGESTED_COUNT} to {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MAX_COUNT} lounges, however a minimum of {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MIN_COUNT} is required.
</>
export const ATTRACTIONS_HELPER_TEXT =
<>
We suggest adding {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_SUGGESTED_COUNT} to {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MAX_COUNT} Area Attractions and Points of Interest, however a minimum of {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MIN_COUNT} is required.
</>
export const BUSINESSES_HELPER_TEXT =
<>
We suggest adding {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_SUGGESTED_COUNT} to {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MAX_COUNT} Area Businesses, however a minimum of {DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MIN_COUNT} is required.
</>
export const LONG_DISTANCE_TRANSPORTATION_HELPER_TEXT =
<>
Please enter at least {DESTINATIONS_CATEGORY_TRANSPORTATION_MIN_COUNT} long distance transportation entry for your hotel and a maximum of {DESTINATIONS_CATEGORY_TRANSPORTATION_MAX_COUNT}.
</>
export const LOCAL_TRANSPORTATION_HELPER_TEXT =
<>
Please enter at least {DESTINATIONS_CATEGORY_TRANSPORTATION_MIN_COUNT} local transportation entry for your hotel and a maximum of {DESTINATIONS_CATEGORY_TRANSPORTATION_MAX_COUNT}.
</>
export const MEETING_ROOMS_HELPER_TEXT =
<>
{HELPER_TEXT_PREFIX}
Here is your opportunity to add information about Meeting Rooms in your hotel. You can add up to {MAX_MEETING_ROOMS_COUNT} Meeting Rooms. If you want to add additional Meeting Rooms, please contact your {LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.
</>
export const INVENTORY_CLOSEOUTS_HELPER_TEXT = 
<>
{HELPER_TEXT_PREFIX}
When your hotel is activated on presell your hotel will be available on choicehotels.com, which is our brand website.
During the presell period, special attention will need to be placed on your available CRS inventory, as your CRS inventory will not automatically reflect any property direct reservations or group bookings.
This is your opportunity to close out dates that you do not want Choice to sell any rooms. 
This would be for dates where the hotel has previously sold all of the rooms.
When your hotel goes on presell you will have full access to and be able to modify Rates, Inventory, Blackout dates, Close out dates, and stay restrictions through Choice Central.
If you have any questions please contact your {LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.
</>
export const BOX_INVENTORY_PAGE_HELPER_TEXT=
<>
{HELPER_TEXT_PREFIX}
This page is where you will input the information about Box Inventory.
</>
export const BOX_INVENTORY_PAGE_ROOM_TYPE_HELPER_TEXT=
<>
Select the room types you would like to be sold for these bookings.
</>
export const BOX_INVENTORY_PAGE_ROOM_TYPE_BOX_ADA_HELPER_TEXT=
<>
Select the room types you would like to be sold for these bookings.<br />
Please make sure you select all of your ADA Accessible room types to avoid any ADA issues.
ADA rooms are marked with an <span className='text-orange'>*</span>.
</>
export const OTA_RATE_PROGRAMS_HELPER_TEXT =
<>
{HELPER_TEXT_PREFIX}
These are the online rate programs that Choice endorses. Deselect any rate program you prefer not to participate in.
The inventory for these rateplans is controlled by the inventory box "NET" that you set up on the previous screen.
Financial Information is required when participation is selected in any Third Party Rate Program.
</>
export const OTA_RATE_PROGRAMS_SCANDANAVIAN_HELPER_TEXT =
<>
{HELPER_TEXT_PREFIX}
These are the online rate programs that Choice endorses. Deselect any rate program you prefer not to participate in.
Financial Information is required when participation is selected in any Third Party Rate Program.
</>
export const OTA_RATE_PROGRAMS_FINANCIAL_INFO_BANNER_TEXT =
'Financial Information is required when participation is selected in any of the Third Party Rate Programs above.'
export const OTA_RATE_PROGRAMS_FINANCIAL_INFO_HELPER_TEXT =
'The information entered below will be used for all selected Third Party Rate Programs.'
export const OTA_RATE_PROGRAMS_NO_ROOM_TYPES_HELPER_TEXT =
<>
No room type details found for the box "NET". If you wish to participate in these programs, please select the inventory and room types for this box in the Box Inventory page.
</>
export const OTA_RATE_PROGRAMS_NO_ROOM_TYPES_SCANDANAVIA_HELPER_TEXT = 
<>
No room type details found. Please finish the Room Types section first.
</>
export const RATEPLAN_BLACKOUTS_HELPER_TEXT = 
<>
{HELPER_TEXT_PREFIX}
This page will give you an opportunity to enter any Blackout dates, which are used to close out inventory 
for a particular rate program.
For example, during high demand times you may not want to sell any Government Rates or Choice Employee Rates, 
so a blackout date would close out these rate plans only. 
Please note you do have a limited amount of Blackout Dates per calendar year.
If you have questions, please consult your {LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.
</>

export const FEEDBACK_HELPER_TEXT_HOTEL_CONTACT =
<>
If there is an issue with the Hotel’s brand listed on the form, please contact your {LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR} before moving forward. 
Please note a few items listed will require addendums to be processed, before the updated information is reflected. 
These changes include discrepancies with room count and property address. Please provide any additional feedback below.
</>
export const FEEDBACK_HELPER_TEXT_ADMIN =
<>
The property provided some INFORMATION, which may require further action prior to moving forward.
</>
export const FEEDBACK_HELPER_TEXT_ADMIN_STATUS_CHANGE =
<>
Please enter your feedback or the reason for status change in the text area provided below.
</>

export const FEEDBACK_HELPER_TEXT_DEFAULT = 
<>
Please enter your feedback in the text area provided below.
</>

/*
Terms and Conditions
*/
export const TERMS_AND_CONDITIONS = `
CHOICEPROP-EL™ Terms of Use

Choice Hotels International, Inc., its subsidiaries and/or affiliated companies (collectively, “Choice”) offers CHOICEPROP-EL™ (the “Application”) subject to these terms of use.  By accessing and using the Application, you, and if applicable, the company or legal entity that you represent (“You” or “Your”, as appropriate), are entering into a binding agreement with Choice and You agree to be bound by these terms of use (the “Agreement”):
1.	You represent and warrant that You are a Choice franchisee and or/the franchisee’s “Designated Representative” (as defined in Your franchise agreement with Choice).

2.	Subject to the terms and conditions herein, You may access and use the Application solely for Your own lawful, internal business purposes in connection with the onboarding of your hotel into the Choice franchise system (i.e. from the time You execute a franchisee agreement with Choice until all applicable hotel level data is loaded into all applicable Choice systems). Choice will terminate your access to the Application once all applicable hotel level data is loaded into all applicable Choice systems,

3.	Usage of the Application is voluntary and You may terminate Your usage of and access to the Application without penalty at any time.

4.	You may access the Application through the Choice Openings Portal  (“Account”). You shall keep all such Account information strictly confidential and shall not share such information with any third party.  You shall be responsible for any and all actions taken using Your Account.

5.	In connection with Your use of the Application, Choice may send You service announcements, administrative messages, and other information.

6.	Choice reserves the right, at any time and without advance notice to You, to add or remove functionalities or features of the Application and may suspend or stop the Application altogether. Choice controls, in its sole and absolute discretion, Your access to functionalities or features of the Application.      

7.	You shall not (a) create any derivative works based upon the Application or reverse engineer, reverse assemble, decompile or otherwise attempt to drive source code from the Application or any part thereof (except to the extent that such restriction is not permitted by applicable law), (b) make the Application available to any unauthorized parties, including, without limitation, competitors of Choice, or (c) disrupt the normal flow of dialogue or otherwise act in a manner that negatively affects other users' ability to use the Application.

8.	In connection with Your use of the Application, Choice also collects certain types of data and information, including but not limited to trends on rate recommendations, acceptance of recommendations by end users, logins, and general use of the Application. Such data and information is used by Choice primarily to understand how end users use the Application, to make improvements and enhancements to the Application as well as assisting Choice Area Directors in providing coaching and training to Application end users.  

9.	As between the parties, Choice or its suppliers owns all right, title and interest in and to the Application (including all patent, copyright, trade secret and other intellectual property rights) and any and all related and underlying technology and documentation. This Agreement does not give You any rights in any ownership of any intellectual property rights in the Application or the content You access. This agreement does not grant You the right to use any branding or logos used in the Application.

10.	You acknowledge and agree that Choice may monitor Your usage of the Application for the purpose of confirming compliance with this Agreement, or as may otherwise be permitted by applicable law.

11.	YOU AGREE THAT CHOICE HAS MADE NO EXPRESS WARRANTIES TO YOU REGARDING THE APPLICATION AND THAT THE APPLICATION AND CONTENT THEREIN IS BEING PROVIDED TO YOU "AS IS" WITHOUT WARRANTY OF ANY KIND. CHOICE DISCLAIMS ALL WARRANTIES WITH REGARD TO THE APPLICATION, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF FITNESS FOR A PARTICULAR PURPOSE, MERCHANTABILITY, MERCHANTABLE QUALITY, NONINFRINGEMENT OF THIRD-PARTY RIGHTS, OR RESULTS.  CHOICE DOES NOT WARRANT AGAINST INTERFERENCE WITH YOUR ENJOYMENT OF THE APPLICATION, THAT THE FUNCTIONS CONTAINED IN, OR SERVICES PERFORMED OR PROVIDED BY, THE APPLICATION WILL MEET YOUR REQUIREMENTS, THAT THE OPERATION OF THE APPLICATION OR SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, OR THAT DEFECTS IN THE APPLICATION OR SERVICES WILL BE CORRECTED. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY CHOICE OR ITS AUTHORIZED REPRESENTATIVE SHALL CREATE A WARRANTY. Some states or jurisdictions do not allow the exclusion of implied warranties, so the above limitations may not apply to You in their entirety.

12.	SUBJECT TO APPLICABLE LAW, CHOICE AND CHOICE’S SUPPLIERS, WILL NOT BE RESPONSIBLE FOR LOST PROFITS, REVENUES, OR DATA, FINANCIAL LOSSES OR INDIRECT, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES. SUBJECT TO APPLICABLE LAW, THE TOTAL LIABILITY OF CHOICE AND ITS SUPPLIERS, FOR ANY CLAIMS UNDER THIS AGREEMENT, INCLUDING FOR ANY IMPLIED WARRANTIES, IS LIMITED TO THE AMOUNT YOU PAID US TO USE THE APPLICATION DURING THE TWELVE MONTHS PRECEEDING THE FIRST INCIDENT OUT OF WHICH THE LIABILITY AROSE. IN ALL CASES, CHOICE AND ITS SUPPLIERS, WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE THAT IS NOT REASONABLY FORESEEABLE. 

13.	Access to the Application is limited.  You acknowledge and agree that the Application contains confidential material, including trade secrets, belonging to Choice.  Therefore, You may not disclose the Application or data contained in or resulting from the operation of the Application, including Application content, to third parties without the prior express written consent of Choice.  Excluded from this requirement is (a) information already available to or in Your possession prior to disclosure through use of the Application; (b) information that is or becomes lawfully available to the public; or (c) information acquired from a person who is not known to You to be in breach of an obligation of confidentiality.  Should You be compelled to disclose any confidential information relating to the Software or this Site by lawful order, subpoena, or other means of compulsion of a court or other tribunal of competent jurisdiction, You agree to provide Choice with immediate written notice of such impending disclosure and cooperate in and to take all steps reasonably necessary to protect the confidentiality of the information, including cooperating in obtaining a protective order and disclosing only that which is required by such order, subpoena, or means of compulsion

14.	To the extent that You provide Feedback (as defined herein) to Choice, whether before, during or after the term of this Agreement, and Choice incorporates such Feedback in the Application, You hereby grant to Choice and Choice accepts, a worldwide, non-exclusive, perpetual, irrevocable, royalty-free license, with the right to sublicense, under its intellectual property rights to the Feedback, to incorporate or otherwise utilize Feedback as provided by You to Choice in the design and implementation of Choice products including the Application, and to design, debug, display, perform, copy, make, have made, use, sell, and otherwise dispose of and support Choice's and its sublicensees’ products and documentation embodying such Feedback in any manner and via any media Choice chooses, without reference to the source. Notwithstanding the foregoing, Choice shall have no right or license under Your intellectual property, by implication, estoppels or otherwise under this Agreement, except as to the Feedback provided to Choice and intended for incorporation into any of Choice's products and services. For the purpose of this Agreement, “Feedback” means (i) Your requirements, input, comments, responses, opinions, and feedback concerning the definition, design, use or operation of the Application and related product documentation or (ii) Your technical system requirements for Choice to include in the Application definition, design, implementation, use or operation, as provided by You from time to time.

15.	You will hold harmless and indemnify Choice and its officers, agents, and employees from any claim, suit or action arising from or related to the use of the Application or violation of this Agreement, including any liability or expense arising from claims, losses, damages, suits, judgments, litigation costs and attorneys’ fees.

16.	Choice reserves the right, at any time and without advance notice to You, to change the terms of this Agreement by posting a revised version of the Agreement in the Application, and You are responsible for regularly reviewing the Agreement.  Your continued use of the Application after the effective date of such changes will constitute acceptance of and agreement to any such changes. 

17.	This Agreement is effective until terminated by You or Choice. Your rights under this Agreement will terminate automatically without notice from Choice if You fail to comply with any term(s) of this Agreement. Upon termination of the Agreement, You shall cease all use of the Application.  Choice may terminate this Agreement at any time, with or without cause, by terminating Your Account, otherwise ceasing to make the Application available to You, or by providing written notification of termination to You. Choice may terminate, either temporarily or permanently, Your access to individual functionalities or features of the Application.  Termination of this Agreement will not relieve You of any liability for any breach of, or liability accruing under, this Agreement prior to termination.

18.	If You do not comply with this Agreement, and Choice does not take action right away, that does not mean that Choice is waiving any rights that Choice may have (such as taking action in the future). 

19.	If a particular term of this Agreement is not enforceable as written under applicable law, this will not affect any other terms of the Agreement.

20.	The laws of the State of Maryland, USA, excluding Maryland’s conflict of laws rules, will apply to any disputes arising out of or relating to the Agreement or the Application. All claims arising out of or relating to this Agreement or the Application will be litigated exclusively in the federal or state courts of the State of Maryland, USA, and You and Choice consent to personal jurisdiction in those courts. Notwithstanding the foregoing, neither the Uniform Computer Information Transactions Act (“UCITA”) nor the United Nations Convention on Contracts for the International Sale of Goods shall apply to this Agreement or the Application.  To the extent UCITA is applicable notwithstanding the foregoing, the parties agree to opt out of the applicability of UCITA pursuant to the “opt out” provisions contained therein.

For Franchisees of Choice Hotels Canada Inc.:

21.	As used in this Agreement, and for the avoidance of doubt, “Choice” includes Choice Hotels Canada Inc. (“Choice Canada”).

22.	The parties hereto confirm that it is their wish that this Agreement, as well as all other documents relating hereto, including all notices, have been and shall be drawn up in the English Language only. Les parties aux présentes confirment leur volonté que cette convention, de même que tous les documents, y compris tout avis, qui s’y rattachent, soient rédigés en langue anglaise.

23.	You acknowledge and agree that while Choice Canada is not a party to this Agreement and has no obligations under this Agreement, Choice Hotels International, Inc., and its non-Choice Canada subsidiaries and/or affiliates are a trustee of Choice Canada for the limited purpose of holding in trust for Choice Canada the covenants in favor of Choice Canada. Accordingly, the parties hereto agree that Choice Canada may enforce or rely on such rights and promises in its own right (without being required to add Choice Hotels International, Inc., and any non-Choice Hotels Canada subsidiary and/or affiliate as a party to any proceedings for such enforcement).
`
